<template>
    <div class="d-inline position-relative">
        <input v-bind="$attrs"
               v-on="$listeners"
               class="form-control form-control-sm d-inline search-input"
               :class="inputClasses"
               type="search"
               placeholder="Search"
               aria-label="Search">
        <span class="search-icon">
            <i class="fal fa-search"></i>
        </span>
    </div>
</template>

<script>
export default {
    name: 'AppSearchInput',
    props: {
        inputClasses: {
            type: String,
            required: false,
            default: ''
        }
    },
    inheritAttrs: false
}
</script>

<style scoped lang="scss">
.search-icon {
    left: 10px;
    top: 3px;
    font-size: 13px;
    color: #a8b3bd !important;
    position: absolute;
}

.search-input {
    padding-left: 30px;

    &::placeholder {
        font-size: 14px;
        color: #a8b3bd;
    }
}
</style>
